'use client';

import React from 'react';
import Link from 'next/link';
import styles from './StyledButton.module.scss';

interface Props {
    href: string;
    children: React.ReactNode;
}

const StyledButton = ({ href, children }: Props) => {
    return (
        <Link href={href} className={styles.button}>
            {children}
        </Link>
    );
};

export default StyledButton;
